

































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  GET_PAGE_DATA,
  ACCEPT_COOKIE,
  DECLINE_COOKIE,
} from '../store/actions.names';
import { Action, Getter } from 'vuex-class';
import '../utils/register-hooks';
import CookieLaw from 'vue-cookie-law';
import {
  pageDataType,
  MainMenuItem,
  RmainMenuItem,
  GlobalItem,
} from '../store/store.types';

import {
  TimelineMax,
  CSSPlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo,
} from 'gsap/all';
import { PAGE_DATA, PAGE_TYPE, COOKIE_CONSENT } from '../store/getters.names';
import HomePage from './HomePage.vue';
import BasicPage from './BasicPage.vue';
import ContactPage from './ContactPage.vue';
import JobDetailsPage from './JobDetailsPage.vue';
import JobIndexPage from './Employment.vue';
import NewsIndexPage from './NewsIndexPage.vue';
import NewsPage from './NewsPage.vue';

import {
  FETCH_MAIN_MENU,
  FETCH_RMAIN_MENU,
  FETCH_GLOBAL,
} from '../store/actions.names';
import axios from 'axios';

@Component({
  name: 'Page',
  components: {
    HomePage,
    BasicPage,
    ContactPage,
    JobDetailsPage,
    JobIndexPage,
    NewsIndexPage,
    NewsPage,
    CookieLaw,
  },
})
export default class Page extends Vue {
  public cookieOptDialogue: boolean = false;

  @Getter('mainMenu') public mainMenu!: MainMenuItem[];
  @Getter('rmainMenu') public rmainMenu!: RmainMenuItem[];
  @Getter('global') public global!: GlobalItem;
  @Action(FETCH_MAIN_MENU) public [FETCH_MAIN_MENU]: any;
  @Action(FETCH_GLOBAL) public [FETCH_GLOBAL]: any;
  @Action(FETCH_RMAIN_MENU) public [FETCH_RMAIN_MENU]: any;
  @Action(GET_PAGE_DATA) public getPageData: any;
  @Getter(PAGE_DATA) public pageData!: pageDataType;
  @Getter(PAGE_TYPE) public pageType!: string;
  @Getter(COOKIE_CONSENT) public cookieConsent!: boolean | null;
  @Action(ACCEPT_COOKIE) public acceptCookie: any;
  @Action(DECLINE_COOKIE) public declineCookie: any;

  public tween: any = new TimelineMax({
    paused: true,
    onComplete() {
      clearProps: 'all';
    },
  });

  public menuBarTl: any = new TimelineMax({ paused: true });
  public menuPopUp: number | null = null;
  public mobileNav: boolean = true;
  public showNav: boolean = false;

  @Watch('pageData')
  public handlePageDataChange(val: any, oldVal: any) {
    document.title = `${this.pageData.title} | ${this.global.site_title}`;
  }

  @Watch('cookieConsent')
  public handleCookieConsentChange(val: any, oldVal: any) {
    if (val !== oldVal) {
      if (val === true) {
        this.$ga.enable();
      } else {
        this.$ga.disable();
      }
    }
  }

  public handleView() {
    this.mobileNav = window.innerWidth <= 1250;
    window.addEventListener('resize', this.handleView);
  }

  public popUpHandler(isActive: boolean, item: any, idx: number) {
    if (item.children.length > 0) {
      this.menuPopUp = isActive ? idx : null;
    }
  }

  public cookieOptIn() {
    this.acceptCookie();
    this.cookieOptDialogue = false;
  }

  public cookieOptOut() {
    this.declineCookie();
    this.cookieOptDialogue = false;
  }

  public nestedNavAnim(el: HTMLElement, done: boolean) {
    TweenMax.fromTo(
      el,
      1,
      {
        xPercent: -100,
      },
      {
        xPercent: 0,
        ease: Expo.easeOut,
      }
    );
  }

  public navAnimLeave(el: HTMLElement, done: boolean) {
    TweenMax.fromTo(
      el,
      1,
      {
        xPercent: 0,
      },
      {
        xPercent: -120,
        ease: Expo.easeOut,
      }
    );
  }

  public created() {
    this.handleView();
  }

  public beforeRouteUpdate(to: any, from: any, next: any) {
    if (this.showNav) {
      this.showNav = false;
      this.menuBarTl.reverse();
    }
    this.menuPopUp = null;

    next();
  }

  public menuAnim() {
    this.menuBarTl.reversed(!this.menuBarTl.reversed());
    this.showNav = !this.showNav;
  }

  public mounted() {
    this[FETCH_MAIN_MENU]();
    this[FETCH_RMAIN_MENU]();
    this[FETCH_GLOBAL]();

    this.menuBarTl
      .to('.two', 0.3, { autoAlpha: 0, ease: Expo.easeOut })
      .to('.one', 0.3, { rotation: 45, y: 12, ease: Expo.easeOut }, '-=0.2')
      .to('.three', 0.3, { y: -10, rotation: -45, ease: Expo.easeOut }, '-=0.2')
      .reverse();
  }
}
